import { Module } from 'vuex';
import { RootState, Testimonial } from 'frontend/types';
import { getJson } from 'frontend/utils/ajax';
import { appendGetParams } from 'frontend/utils/urls';

interface TestimonialsState {
  items: Testimonial[];
  totalPages: number;
  page?: number;
  isBusy?: boolean;
}

const API_URL = '/testimonials/list/';

const SOURCES: { [key: number]: string } = {
  0: '',
  1: 'Google Play',
  2: 'App Store',
  3: 'Twitter',
};

const USER_CATEGORIES: { [key: number]: string } = {
  0: 'Life-long learners',
  1: 'Students',
  2: 'Parents',
  3: 'Teachers',
  4: 'Professionals',
};

const testimonials: Module<TestimonialsState, RootState> = {
  namespaced: true,
  state: {
    items: [] as Testimonial[],
    totalPages: 0,
    page: 1,
    isBusy: false,
  },
  mutations: {
    setValue(state: TestimonialsState, value: TestimonialsState): void {
      state.items = value.items || [];
      state.totalPages = value.totalPages || 0;
    },
    setItems(state: TestimonialsState, value: Testimonial[]): void {
      state.items = value;
    },
    setTotalPages(state: TestimonialsState, value: number): void {
      state.totalPages = value;
    },
    setCurrentPage(state: TestimonialsState, value: number): void {
      state.page = value;
    },
    setIsBusy(state: TestimonialsState, value: boolean): void {
      state.isBusy = value;
    },
  },
  getters: {
    sourceLabel(state, getters): (key: number) => string {
      return (key: number) => SOURCES[key] || '';
    },
    userCategoryLabel(state, getters): (key: number) => string {
      return (key: number) => USER_CATEGORIES[key] || '';
    },
  },
  actions: {
    async changeCurrentPage(
      { commit },
      params: { page: number; type: 'Featured' | 'All'; userCategory: number | null },
    ) {
      commit('setIsBusy', true);

      const baseUrl = `${API_URL}${params.page}/`;
      const urlParams = {
        featured: params.type === 'Featured',
        userCategory: params.userCategory !== null ? params.userCategory : '',
      };
      const response = await getJson(appendGetParams(baseUrl, urlParams));

      commit('setItems', response.results.items);
      commit('setCurrentPage', params.page);
      commit('setIsBusy', false);
    },
    async changeFilters(
      { commit },
      params: { type: 'Featured' | 'All'; userCategory: number | null },
    ) {
      commit('setIsBusy', true);

      const page = 1;
      const baseUrl = `${API_URL}${page}/`;
      const urlParams = {
        featured: params.type === 'Featured',
        userCategory: params.userCategory !== null ? params.userCategory : '',
      };
      const response = await getJson(appendGetParams(baseUrl, urlParams));

      commit('setCurrentPage', page);
      commit('setTotalPages', response.results.totalPages);
      commit('setItems', response.results.items);
      commit('setIsBusy', false);
    },
  },
};

export default testimonials;
